import { getType } from 'typesafe-actions'
import { cloneDeep } from 'lodash'

import * as actions from './actions'
import { StoreState, ConfigAction } from './types'
import produce from 'immer'
import parseErrorMessage from 'utils/parseErrorMessage'
import { Event } from '../../types/event'
import { sortingListConfig } from './function'

const initEvent = {
  IsLoading: false,
  MessageSuccess: undefined,
  SubmitError: undefined,
  SubmitSuccess: false,
  SubmitType: undefined,
} as Event

const initList = {
  Total: 0,
  List: [],
}

const initialState: StoreState = {
  event: cloneDeep(initEvent),
  DataList: cloneDeep(initList),
  CountTypeList: cloneDeep(initList),
  sorting: {
    name: 'Sequence',
    type: 'asc',
  },
}

export default function(
  state: StoreState = initialState,
  action: ConfigAction
): StoreState {
  return produce(state, draft => {
    switch (action.type) {
      case getType(actions.getDataListAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.DataList = {
          List: [],
          Total: 0,
        }
        break
      case getType(actions.getDataListAction.success):
        draft.event.IsLoading = false
        const data = action.payload.ResponseData
        const dataSort = sortingListConfig(
          data.List,
          draft.sorting.type,
          draft.sorting.name
        )
        draft.DataList = {
          Total: data.Total,
          List: dataSort,
        }
        break

      case getType(actions.getCountTypeListAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.CountTypeList = {
          List: [],
          Total: 0,
        }
        break
      case getType(actions.getCountTypeListAction.success):
        draft.event.IsLoading = false
        const countTypeList = action.payload.ResponseData
        draft.CountTypeList = {
          Total: countTypeList.Total,
          List: countTypeList.List,
        }
        break

      case getType(actions.createDataAction.request):
      case getType(actions.updateDataAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        break
      case getType(actions.createDataAction.success):
      case getType(actions.updateDataAction.success):
        draft.event.IsLoading = false
        draft.event.SubmitError = undefined
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'ทำรายการสำเร็จ'
        break

      case getType(actions.createDataAction.failure):
      case getType(actions.updateDataAction.failure):
      case getType(actions.getDataListAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        break

      case getType(actions.sortingTask):
        const sorting = state.sorting
        const params = action.payload
        if (sorting.name === params.name) {
          draft.sorting.type = sorting.type === 'asc' ? 'desc' : 'asc'
        } else {
          draft.sorting.name = params.name
          draft.sorting.type = 'asc'
        }
        if (params.sort != null) {
          draft.sorting.type = params.sort
        }

        const list = sortingListConfig(
          draft.DataList.List,
          draft.sorting.type,
          draft.sorting.name
        )
        draft.DataList.List = list
        break

      case getType(actions.resetEvent):
        draft.event = cloneDeep(initEvent)
        break

      default:
        return state
    }
  })
}
